// extracted by mini-css-extract-plugin
export default {"avatarOuter":"Avatar-module__avatarOuter--MZJZH","avatarInner":"Avatar-module__avatarInner--rVuJD"};